export default "__VITE_ASSET__BrFtFMGF__"